import React from 'react';
import ProfileComponent from '../components/Profile/Profile';

function ProfilePage() {
  return <ProfileComponent />;
}

export default ProfilePage;
